import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getOrderStatusMappingDataView } from "@insite/client-framework/Store/Data/OrderStatusMappings/OrderStatusMappingsSelectors";
import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import { OrderStatusMappingModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import Select, { SelectProps } from "@insite/mobius/Select";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import loadDiscrepancyCollection from "@tKgpco/Store/Data/DiscrepancyHistory/Handlers/loadDiscrepancyCollection";
import loadRMACollection from "@tKgpco/Store/Data/RMA/Handlers/loadRMACollection";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        parameter: state.KGPState.RMAStore.RMACollectionParams,
    };
};

const mapDispatchToProps = {
    updateSearchFields,
    loadRMACollection,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface RMAHistorySearchFieldStatusStyles {
    select?: SelectProps;
    wrapper?: SearchFieldWrapperStyles;
}

export const statusStyles: RMAHistorySearchFieldStatusStyles = {};
const styles = statusStyles;

class RMAHistorySearchFieldStatus extends React.Component<Props> {
    handleChange = (event: React.FormEvent<HTMLSelectElement>) => {
        if (event.currentTarget.value) {
            this.props.loadRMACollection({
                ...this.props.parameter,
                status: event.currentTarget.value.split(","),
            });
        } else {
            this.props.loadRMACollection({ ...this.props.parameter, status: undefined });
        }
    };

    render() {
        const value =
            this.props?.parameter?.status && this.props?.parameter?.status?.length > 0
                ? this.props.parameter.status.join(",")
                : "";

        return (
            <SearchFieldWrapper extendedStyles={styles.wrapper}>
                <Select
                    label={translate("Status")}
                    {...styles.select}
                    value={value}
                    onChange={this.handleChange}
                    data-test-selector="rmaHistory_filterStatus"
                >
                    <option value="">{translate("Select")}</option>
                    <option value="Open">{translate("Open")}</option>
                    <option value="In Progress">{translate("In Progress")}</option>
                    <option value="Pending">{translate("Pending")}</option>
                    <option value="Complete">{translate("Complete")}</option>
                </Select>
            </SearchFieldWrapper>
        );
    }
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RMAHistorySearchFieldStatus),
    definition: {
        group: "Common",
        displayName: "RMA History Status",
    },
};

export default widgetModule;
